import { SvgChevronright, SvgDelete } from '@common/icon';
import { cn } from '@core/utils';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';

import giftHeartImage from './_assets/gift-heart.png';

const themeStyles = {
  white: {
    container: 'bg-Gray-white bg-opacity-100',
    title: 'text-B-400',
    subtitle: 'text-Gray-700',
    closeButton: 'text-Gray-600',
  },
  black: {
    container: 'bg-Gray-black bg-opacity-70',
    title: 'text-Gray-white',
    subtitle: 'text-B-300',
    closeButton: 'text-Gray-400',
  },
};

export interface DonationBenefitToastProps {
  onClose?: () => void;
  theme: 'white' | 'black';
  href?: string;
}

interface CloseButtonProps {
  onClose?: () => void;
  theme: 'white' | 'black';
}

interface ContentProps {
  theme: 'white' | 'black';
  href?: string;
}

const CloseButton = ({ onClose, theme }: CloseButtonProps) => (
  <button
    type="button"
    aria-label="닫기"
    onClick={onClose}
    className={cn(
      'absolute inset-y-0 right-0 z-50 flex w-50 items-center justify-center',
      themeStyles[theme].closeButton,
    )}
  >
    <SvgDelete className="size-14" />
  </button>
);

const Content = ({ theme, href }: ContentProps) => (
  <>
    <Image
      alt="선물"
      height={34}
      src={giftHeartImage.src}
      width={34}
      className="size-34 shrink-0"
      unoptimized
    />
    <div className="font-500 typo-body4">
      <p className={cn('whitespace-nowrap', themeStyles[theme].title)}>
        10만원 기부 → 10만원 모두 세액공제!
      </p>
      <p className={themeStyles[theme].subtitle}>
        기부하시고 답례품도 받으세요!
      </p>
    </div>
    {href ? (
      <div className="absolute inset-y-0 right-0 flex w-50 items-center justify-center">
        <SvgChevronright
          className={cn('size-16', themeStyles[theme].closeButton)}
        />
      </div>
    ) : null}
  </>
);

export const DonationBenefitToast = ({
  onClose,
  theme,
  href,
}: DonationBenefitToastProps) => {
  const currentTheme = themeStyles[theme];

  return (
    <div
      className={cn(
        'pointer-events-auto relative flex items-center gap-8 rounded-pill py-16 pl-32 pr-48 backdrop-blur-lg',
        currentTheme.container,
      )}
    >
      {href ? (
        <CustomLink href={href} className="flex items-center gap-8">
          <Content theme={theme} href={href} />
        </CustomLink>
      ) : (
        <>
          <Content theme={theme} />
          <CloseButton onClose={onClose} theme={theme} />
        </>
      )}
    </div>
  );
};
